// St. Bordeaux Theme JS

document.addEventListener('DOMContentLoaded', () => {

  // ── Fade-in on scroll ──────────────────────
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.product-card, .testimonial-card, .brand-promise__item').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    observer.observe(el);
  });

  // ── Quick Add to Cart ──────────────────────
  document.querySelectorAll('.product-card__quick-add').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const card = btn.closest('.product-card');
      const productLink = card.querySelector('a[href*="/products/"]');
      if (!productLink) return;

      const handle = productLink.href.split('/products/')[1]?.split('?')[0];
      if (!handle) return;

      btn.textContent = '...';

      try {
        const resp = await fetch(`/products/${handle}.js`);
        const product = await resp.json();
        const variantId = product.variants[0]?.id;
        if (!variantId) return;

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        btn.textContent = '✓ Added';
        btn.style.background = 'var(--gold)';

        // Update cart count
        const cartResp = await fetch('/cart.js');
        const cart = await cartResp.json();
        const countEl = document.querySelector('.cart-count');
        if (countEl) {
          countEl.textContent = cart.item_count;
          countEl.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
        }

        setTimeout(() => {
          btn.textContent = 'Add to Cart';
          btn.style.background = '';
        }, 2000);

      } catch (err) {
        btn.textContent = 'Add to Cart';
        console.error(err);
      }
    });
  });

  // ── Variant selector (product page) ───────
  const variantBtns = document.querySelectorAll('[data-option]');
  if (variantBtns.length) {
    const productForm = document.getElementById('product-form');

    variantBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const optionPos = btn.dataset.option;
        // Deselect siblings
        document.querySelectorAll(`[data-option="${optionPos}"]`).forEach(b => {
          b.classList.remove('active');
        });
        btn.classList.add('active');

        // Find matching variant
        const selectedValues = {};
        [1, 2, 3].forEach(pos => {
          const active = document.querySelector(`[data-option="${pos}"].active`);
          if (active) selectedValues[pos] = active.dataset.value;
        });

        // This is a simplified variant match; Shopify normally handles this via variant data
        // For full implementation, output product JSON and match here
      });
    });
  }

  // ── Sticky header shadow on scroll ────────
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 20) {
        header.style.boxShadow = '0 2px 20px rgba(44,36,22,0.08)';
      } else {
        header.style.boxShadow = 'none';
      }
    }, { passive: true });
  }

});
